import React, { FC } from 'react'
import styled from 'styled-components'

import { getProjectName } from '../../../lib/get-project-name'
import { createMediaStyles } from '../../../lib/styled-helpers'
import { Button } from '../../../ui/button'
import { Icon } from '../../../ui/icon'

export const FullInfoAboutCar: FC<{
  onCTAButtonCLick: () => void
  id: string
}> = ({ onCTAButtonCLick, id }) => {
  const handleButtonClick = () => {
    document.dispatchEvent(new CustomEvent('kodix:ecom:fullInfoButtonClicked', { detail: { carId: id } }))
    onCTAButtonCLick()
  }

  return (
    <Wrap>
      <Title>Полная информация об автомобиле</Title>
      <Subtitle>Лист диагностики и проверка по VIN в Автотеке — бесплатно.</Subtitle>
      <List>
        <ListInner>
          <ListTitle>Проверка по VIN</ListTitle>
          <ListItem>
            <Icon name="check" size={1} /> Поиск фактов ДТП, расчётов стоимости ремонтов и страховых выплат
          </ListItem>
          <ListItem>
            <Icon name="check" size={1} /> Проверка на участие в аварийном аукционе, работу в такси и каршеринге
          </ListItem>
        </ListInner>
        <ListInner>
          <ListTitle>Диагностика авто</ListTitle>
          <ListItem>
            <Icon name="check" size={1} /> Техническое состояние проверено
          </ListItem>
          <ListItem>
            <Icon name="check" size={1} /> Кузов осмотрен, толщина лакокрасочного покрытия измерена
          </ListItem>
          <ListItem>
            <Icon name="check" size={1} /> Интерьер осмотрен
          </ListItem>
          <ListItem>
            <Icon name="check" size={1} /> Комплектация подтверждена
          </ListItem>
        </ListInner>
      </List>
      <Button customSize={'4.4rem'} textSize={'1.5rem'} block={false} onClick={() => handleButtonClick()}>
        Запросить информацию
      </Button>
    </Wrap>
  )
}

const Wrap = styled.div`
  padding-right: 50px;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 263px;
    height: 239px;
    ${({ theme }) =>
      createMediaStyles(() => ({
        phone: `display: none`,
        tablet: `display: block`,
        desktop: 'display: none',
        projectors: 'display: block'
      }))}
  }
  ${() =>
    createMediaStyles(() => ({
      phone: `padding: 0 15px 40px`,
      tablet: 'padding: 0; margin-bottom: 79px'
    }))}
`

const Title = styled.div`
  ${({ theme }) =>
    getProjectName() === 'avito'
      ? 'font-weight:800; font-family: "Manrope",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto" ,"Helvetica Neue", Arial, sans-serif,  "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
      : theme.textStyles.p2};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
  max-width: 75%;
  ${({ theme }) =>
    createMediaStyles(() => ({
      phone: `max-width: none; font-size: 2.4rem; line-height: normal;`,
      tablet: `max-width: 75%;`,
      desktop: 'max-width: none; font-size:3.2rem; line-height: 40px;',
      projectors: 'max-width: 75%'
    }))}
`

const Subtitle = styled.div`
  ${({ theme }) =>
    getProjectName() === 'avito'
      ? 'font-family: "Manrope",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto" ,"Helvetica Neue", Arial, sans-serif,  "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
      : theme.textStyles.p2};
  font-size: 16px;
  color: ${({ theme }) => theme.palette.black};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`

const List = styled.div`
  display: grid;
  grid-column-gap: 15px;
  ${() =>
    createMediaStyles(() => ({
      phone: `grid-template-columns: 1fr;`,
      tablet: 'grid-template-columns: 1fr 2fr;',
      desktop: 'grid-template-columns: 1fr',
      projectors: 'grid-template-columns: 1fr 2fr; margin-bottom: 15px;'
    }))}
`

const ListInner = styled.div``

const ListTitle = styled.div`
  font-size: 1.6rem;
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  font-weight: 700;
  margin-bottom: ${({ theme }) => theme.spacing[6]};
`

const ListItem = styled.div`
  font-size: 16px;
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing[3]};
  ${({ theme }) =>
    getProjectName() === 'avito'
      ? 'font-family: "Manrope",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto" ,"Helvetica Neue", Arial, sans-serif,  "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
      : theme.textStyles.p2};
`
